import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SplitNumber from "./SplitNumber";
import AddToBasketButton from "./addToBasketButton";
import { isMobile } from "react-device-detect";
import AddToBasketRoundedButton from "./addToBasketRoundedButton";
function CardTileSearch({
  itemImgSrc,
  amusementUrl,
  amusementName,
  amusementPrice,
  amusementFinalPrice,
  handleClick,
}) {
  return isMobile ? (
    <Link to={amusementUrl}>
      <Card className="p-2 rounded-3 text-center">
        <Card.Img
          variant="top"
          src={itemImgSrc + "?width=200"}
          className="rounded-3"
        />
        <Card.Body className="px-0 pb-0">
          <h3 className="text-black fw-bold fs-normal">{amusementName}</h3>
          <Card.Text className="text-black-06 ">
            {amusementFinalPrice > amusementPrice ? (
              <>
                <span className=" text-decoration-line-throught-rotate border-secondary">
                  <SplitNumber number={amusementFinalPrice} />
                </span>
                تومان
              </>
            ) : (
              ""
            )}
          </Card.Text>
          <AddToBasketButton onClick={handleClick} price={amusementPrice} />
        </Card.Body>
      </Card>
    </Link>
  ) : (
    <Link to={amusementUrl}>
      <Card className="p-2 rounded-3 text-center">
        <Card.Img
          variant="top"
          src={itemImgSrc + "?width=300"}
          className="rounded-3"
        />
        <Card.Body className="px-0 pb-0">
          <h3 className="text-black fw-bold fs-normal pb-3 border-bottom">
            {amusementName}
          </h3>
          <Row className="gx-0">
            <Col>
              {amusementFinalPrice > amusementPrice ? (
                <>
                  <span className="text-black-06 fs-08 text-decoration-line-throught-rotate border-secondary">
                    <SplitNumber number={amusementFinalPrice} />
                  </span>
                  <span className="fs-08 ps-1">تومان</span>
                </>
              ) : (
                ""
              )}
              <div className="fw-bold text-black">
                <span className=" text-dark pe-1">
                  <SplitNumber number={amusementPrice} />
                </span>
                تومان
              </div>
            </Col>
            <Col xs="auto" className="my-auto">
              <AddToBasketRoundedButton onClick={handleClick} />
            </Col>
          </Row>

          {/* <AddToBasketButton
            
            price={amusementFinalPrice}
          /> */}
        </Card.Body>
      </Card>
    </Link>
  );
}
export default CardTileSearch;
